import type {
    CustomHeaderGroupProps,
    IHeaderParams,
} from "@/ui/molecules/Grid";

import Typography from "@/ui/atoms/Typography";
import type { BoxProps } from "@/ui/atoms/Box";

export const testIds = {
    main: "GridHeaderWithAction",
    action: "GridHeaderWithAction-action",
};
export const GridHeaderWithAction = (
    props: BoxProps &
        (IHeaderParams | CustomHeaderGroupProps) & {
            textAlign: "center" | "left" | "right";
            extraInfo?: boolean;
            action: React.ReactNode;
            redirect?: () => void;
            url?: string;
        },
) => {
    const {
        displayName,
        textAlign = "left",
        action,
        redirect,
        url,
        sx,
    } = props;

    const handleHeaderClicked = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        if (url !== undefined) {
            window.open(url, "_blank");
        } else {
            redirect?.();
        }
    };

    return (
        <Typography
            variant="h4"
            data-testid={testIds.main}
            sx={{
                width: "100%",
                height: "100%",
                fontWeight: 500,
                textAlign,
                color: "var(--text-color-light)",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                ...sx,
            }}
        >
            <a
                href={url}
                onClick={handleHeaderClicked}
                style={{ width: "100%" }}
                draggable={false}
            >
                {displayName}
            </a>
            <span data-testid={testIds.action}>{action}</span>
        </Typography>
    );
};

export default GridHeaderWithAction;
